import SMTooltip from './SMTooltip';

export default SMTooltip;
